export default __webpack_public_path__ + "static/media/e-ppt-picturemark-d.86a4976a.svg";